module.exports = __webpack_public_path__ + "static/media/dengbg.22173cdf.png";